
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateVendorContactFromCatalogDtoFormGroup() {
return new FormGroup({
    ighSupplierId: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
    subCatalogKey: new FormControl<string | undefined>('', [Validators.maxLength(64)]),
})
;
}
      